<template>
   <center>
    <v-card  class="mb-4 cardUp">
    <v-btn to="/admin/nekretnine" fab class="mr-3 mb-3" color="primary"><v-icon>mdi-arrow-left</v-icon></v-btn>
    <h4 class="mb-3 ml-12"  >Izmena nekretnine</h4>
    </v-card>
   
    <v-card class="form">
      <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
  <v-text-field
  v-model="data.ownerNumber"
  :counter="30"
  label="Broj vlasnika"
  required
></v-text-field>
    <v-text-field
      v-model="data.name"
      :counter="80"
      :rules="nameRules"
      label="Ime"
      placeholder="Na primer: Prodaja, 54m2 , Zabjelo..."
      required
    ></v-text-field>
    <v-text-field
      v-model="data.nameEng"
      :counter="80"
      label="Ime engleski"
      placeholder="Na primer: Selling, 54m2 , Zabjelo..."
      required
    ></v-text-field>
    <v-text-field
      v-model="data.nameRus"
      :counter="80"
      label="Ime ruski"
      placeholder="Na primer: Квартира в белый день..."
      required
    ></v-text-field>
   
    <v-select
      v-model="data.town"
      :items="townSelection"
      :rules="[v => !!v || 'Polje je obavezno']"
      label="Grad"
      required
    ></v-select>
    <v-select
      v-if="data.town === 'Podgorica'"
      v-model="data.settlement"
      :items="settlementSelection"
      label="Naselje"
      clearable
    ></v-select>
    <v-select
      v-model="data.purpose"
      :items="purposeSelection"
      :rules="[v => !!v || 'Polje je obavezno']"
      label="Svrha"
      required
    ></v-select>
    <v-select
      v-model="data.category"
      :items="categorySelection"
      :rules="[v => !!v || 'Polje je obavezno']"
      label="Kategorija"
      required
    ></v-select>
    <v-text-field
      v-model="data.bathroomsNum"
      :counter="30"
      label="Broj kupatila"
      required
    ></v-text-field>
    <v-select
      v-model="data.type"
      :items="typeSelection"
      label="Tip"
      required
    ></v-select>
    <v-text-field
    v-model="data.price"
    :counter="30"
    :rules="nameRules"
    label="Cena"
    required
  ></v-text-field>
  <v-text-field
  v-model="data.size"
  :counter="30"
  :rules="nameRules"
  label="Velicina m2"
  required
></v-text-field>
<div class="editor-wrap mb-4">
  <label class="editor-label">Opis</label>
  <div class="editor-toolbar">
    <button type="button" @click="editors.description.chain().focus().toggleHeading({level:1}).run()" :class="{active: editors.description && editors.description.isActive('heading',{level:1})}">H1</button>
    <button type="button" @click="editors.description.chain().focus().toggleHeading({level:2}).run()" :class="{active: editors.description && editors.description.isActive('heading',{level:2})}">H2</button>
    <button type="button" @click="editors.description.chain().focus().toggleHeading({level:3}).run()" :class="{active: editors.description && editors.description.isActive('heading',{level:3})}">H3</button>
    <span class="toolbar-sep"></span>
    <button type="button" @click="editors.description.chain().focus().toggleBold().run()" :class="{active: editors.description && editors.description.isActive('bold')}"><b>B</b></button>
    <button type="button" @click="editors.description.chain().focus().toggleItalic().run()" :class="{active: editors.description && editors.description.isActive('italic')}"><i>I</i></button>
    <button type="button" @click="editors.description.chain().focus().toggleUnderline().run()" :class="{active: editors.description && editors.description.isActive('underline')}"><u>U</u></button>
    <span class="toolbar-sep"></span>
    <button type="button" @click="editors.description.chain().focus().toggleBulletList().run()" :class="{active: editors.description && editors.description.isActive('bulletList')}">&#8226; Lista</button>
    <button type="button" @click="editors.description.chain().focus().toggleOrderedList().run()" :class="{active: editors.description && editors.description.isActive('orderedList')}">1. Lista</button>
    <span class="toolbar-sep"></span>
    <button type="button" @click="editors.description.chain().focus().unsetAllMarks().clearNodes().run()">Očisti</button>
  </div>
  <editor-content class="editor-content" :editor="editors.description" />
</div>
<div class="editor-wrap mb-4">
  <label class="editor-label">Opis engleski</label>
  <div class="editor-toolbar">
    <button type="button" @click="editors.descriptionEng.chain().focus().toggleHeading({level:1}).run()" :class="{active: editors.descriptionEng && editors.descriptionEng.isActive('heading',{level:1})}">H1</button>
    <button type="button" @click="editors.descriptionEng.chain().focus().toggleHeading({level:2}).run()" :class="{active: editors.descriptionEng && editors.descriptionEng.isActive('heading',{level:2})}">H2</button>
    <button type="button" @click="editors.descriptionEng.chain().focus().toggleHeading({level:3}).run()" :class="{active: editors.descriptionEng && editors.descriptionEng.isActive('heading',{level:3})}">H3</button>
    <span class="toolbar-sep"></span>
    <button type="button" @click="editors.descriptionEng.chain().focus().toggleBold().run()" :class="{active: editors.descriptionEng && editors.descriptionEng.isActive('bold')}"><b>B</b></button>
    <button type="button" @click="editors.descriptionEng.chain().focus().toggleItalic().run()" :class="{active: editors.descriptionEng && editors.descriptionEng.isActive('italic')}"><i>I</i></button>
    <button type="button" @click="editors.descriptionEng.chain().focus().toggleUnderline().run()" :class="{active: editors.descriptionEng && editors.descriptionEng.isActive('underline')}"><u>U</u></button>
    <span class="toolbar-sep"></span>
    <button type="button" @click="editors.descriptionEng.chain().focus().toggleBulletList().run()" :class="{active: editors.descriptionEng && editors.descriptionEng.isActive('bulletList')}">&#8226; Lista</button>
    <button type="button" @click="editors.descriptionEng.chain().focus().toggleOrderedList().run()" :class="{active: editors.descriptionEng && editors.descriptionEng.isActive('orderedList')}">1. Lista</button>
    <span class="toolbar-sep"></span>
    <button type="button" @click="editors.descriptionEng.chain().focus().unsetAllMarks().clearNodes().run()">Očisti</button>
  </div>
  <editor-content class="editor-content" :editor="editors.descriptionEng" />
</div>
<div class="editor-wrap mb-4">
  <label class="editor-label">Opis ruski</label>
  <div class="editor-toolbar">
    <button type="button" @click="editors.descriptionRus.chain().focus().toggleHeading({level:1}).run()" :class="{active: editors.descriptionRus && editors.descriptionRus.isActive('heading',{level:1})}">H1</button>
    <button type="button" @click="editors.descriptionRus.chain().focus().toggleHeading({level:2}).run()" :class="{active: editors.descriptionRus && editors.descriptionRus.isActive('heading',{level:2})}">H2</button>
    <button type="button" @click="editors.descriptionRus.chain().focus().toggleHeading({level:3}).run()" :class="{active: editors.descriptionRus && editors.descriptionRus.isActive('heading',{level:3})}">H3</button>
    <span class="toolbar-sep"></span>
    <button type="button" @click="editors.descriptionRus.chain().focus().toggleBold().run()" :class="{active: editors.descriptionRus && editors.descriptionRus.isActive('bold')}"><b>B</b></button>
    <button type="button" @click="editors.descriptionRus.chain().focus().toggleItalic().run()" :class="{active: editors.descriptionRus && editors.descriptionRus.isActive('italic')}"><i>I</i></button>
    <button type="button" @click="editors.descriptionRus.chain().focus().toggleUnderline().run()" :class="{active: editors.descriptionRus && editors.descriptionRus.isActive('underline')}"><u>U</u></button>
    <span class="toolbar-sep"></span>
    <button type="button" @click="editors.descriptionRus.chain().focus().toggleBulletList().run()" :class="{active: editors.descriptionRus && editors.descriptionRus.isActive('bulletList')}">&#8226; Lista</button>
    <button type="button" @click="editors.descriptionRus.chain().focus().toggleOrderedList().run()" :class="{active: editors.descriptionRus && editors.descriptionRus.isActive('orderedList')}">1. Lista</button>
    <span class="toolbar-sep"></span>
    <button type="button" @click="editors.descriptionRus.chain().focus().unsetAllMarks().clearNodes().run()">Očisti</button>
  </div>
  <editor-content class="editor-content" :editor="editors.descriptionRus" />
</div>

  <v-text-field
      v-model="data.terraceNumber"
      :counter="30"
      label="Sprat"
      required
    ></v-text-field>
    <v-select
      v-model="data.heating"
      :items="heatingSelection"
      label="Klimatizacija"
      required
    ></v-select>

    <v-select
      v-model="data.yard"
      :items="yardSelection"
      label="Dvoriste"
      required
    ></v-select>

    <v-select
      v-model="data.parking"
      :items="parkingSelection"
      label="Parking"
      required
    ></v-select>

    <v-select
      v-model="data.basment"
      :items="basmentSelection"
      label="Podrum"
      required
    ></v-select>

    <v-text-field
    v-model="data.seaDistance"
    :counter="30"
    label="Udaljenost od mora"
    required
  ></v-text-field>

  <v-select
      v-model="data.status"
      :items="statusSelection"
      label="Status"
      required
    ></v-select>

    <v-select
      v-model="data.statusIzdavanje"
      :items="statusIzdavanjeSelection"
      label="Status za izdavanje"
      required
    ></v-select>

    <v-select
      v-model="data.statusProdaje"
      :items="statusProdajeSelection"
      label="Status za prodaju"
      required
    ></v-select>
    <v-select
      v-model="data.agent"
      :items="users"
      item-text='fullName'
      return-object
      filled
      label="Agent"
      required
    ></v-select>
    <v-file-input
    v-model="data.images"
    label="Izaberite fotografije"
    accept="image/*" 
    multiple
    prepend-icon="mdi-paperclip"
  >
    <template v-slot:selection="{ text }">
      <v-chip
        small
        label
        color="primary"
      >
        {{ text }}
      </v-chip>
    </template>
  </v-file-input>
 

    <v-btn
      :disabled="!valid"
      color="primary"
      class="mr-4"
      @click="validate"
    >
    <v-icon>mdi-content-save</v-icon>

      Izmeni nekretninu
      
    </v-btn>
    
    <v-btn
      color="error"
      class="mr-4"
      @click="reset"
    >
    <v-icon>mdi-delete</v-icon>

      Obrisi sva polja
    </v-btn>


  </v-form>
</v-card>

</center>
  </template>
  
  
 <script>
import apiPost from '../../../services/service'
import axios from 'axios'
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'

  export default {
    components: { EditorContent },
    data: () => ({
      editors: {
        description: null,
        descriptionEng: null,
        descriptionRus: null,
      },
      id:'',
      data:{
         agent:'',
         ownerNumber:'',
         name:'',
         nameRus:'',
         nameEng:'',
         town: '',
         settlement:'',
         images:[],
         type:'',
         category:'',
         size:'',
         terraceNumber:"",
         heating:"",
         yard:"",
         parking:"",
         description:"",
         descriptionEng:"",
         descriptionRus:"",
         basment:"",
         seaDistance:"",
         status:"",
         statusIzdavanje:"",
         statusProdaje:"",
         bathroomsNum:"",
         roomsNum:''
      },
      valid: true,
      nameRules: [
        v => !!v || 'Ovo polje je obavezno',
        v => (v && v.length <= 80) || 'Ovo polje mora biti ispod 30 karaktera',
      ],
      settlementSelection: [
        "1 maj",
        "Autobuska stanica",
        "Barutana",
        "Baston",
        "Beri",
        "Bioče",
        "Blok 5",
        "Blok 6",
        "Blok 7",
        "Blok 9",
        "Botun",
        "Brežine",
        "Centar",
        "Central Point",
        "Cijevna",
        "City Kej",
        "City Kvart",
        "Crnci",
        "Cvijetin Brijeg",
        "Dahna",
        "Dajbabe",
        "Dalmatinska ulica",
        "Doljani",
        "Donja Gorica",
        "Donji Kokoti",
        "Drač",
        "Farmaci",
        "Gintaš",
        "Golubovci",
        "Gorica C",
        "Gornja Gorica",
        "Gornji Kokoti",
        "Ibričevina",
        "Kakaricka Gora",
        "Karabursko Polje",
        "Kod Big Fashion-a",
        "Kod Capital Plaze",
        "Kokoti",
        "Komani",
        "Konik",
        "Krivi Most",
        "Kruševac",
        "Kuče",
        "Kuči",
        "Kuće Rakića",
        "Lepa Kata",
        "Lješanska Nahija",
        "Ljubović",
        "Malo Brdo",
        "Mareza",
        "Master Kvart",
        "Masline",
        "Mataguži",
        "Momišići",
        "Murtovina",
        "New City",
        "Nova Dalmatinska",
        "Obala Morače",
        "Pejton",
        "Piperi",
        "Pod Goricom",
        "Pobrežje",
        "Preko Morače",
        "Pričelje",
        "Radovče",
        "Rogami",
        "Sadine",
        "Stanjevića Rupa",
        "Stara Varoš",
        "Stari Aerodrom",
        "Tološi",
        "Tološka šuma",
        "Tuški Put",
        "Velje Brdo",
        "Veruša",
        "Vezirov Most",
        "Vranići",
        "Vrela Ribnička",
        "Zabjelo",
        "Zagorič",
        "Zelenika",
        "Zeta",
        "Zlatica",
      ],
      townSelection: [
      "Andrijevica",
      "Bar",
      "Berane",
      "Bijelo Polje",
      "Budva",
      "Cetinje",
      "Danilovgrad",
      "Gusinje",
      "Herceg Novi",
      "Kolasin",
      "Kotor",
      "Mojkovac",
      "Niksic",
      "Petnjica",
      "Plav",
      "Pluzine",
      "Pljevlja",
      "Podgorica",
      "Rozaje",
      "Savnik",
      "Tivat",
      "Tuzi",
      "Ulcinj",
      "Zabljak"
      ],
      typeSelection: [
        "Bez soba",
        "Garsonjera",
        "Jednosoban",
        "Dvosoban",
        "Trosoban",
        "Cetvorosoban",
        "Petosoban",
      ],
      categorySelection: [
        "Stan",
        "Kuca",
        "Zemljiste",
        "Poslovni prostor",
        "Hotel",
        "Garaza",
        "Ugostiteljski objekat"
      ],
      heatingSelection: [
        "Da",
        "Ne",
      ],
      yardSelection: [
        "Da",
        "Ne",
      ],
      parkingSelection: [
        "Da",
        "Ne",
      ],
      basmentSelection: [
        "Da",
        "Ne",
      ],
      purposeSelection: [
        "Prodaja",
        "Izdavanje",
        "Stan na dan",
      ],
      statusSelection: [
        "Namjesteno",
        "Nenamjesteno",
      ],
      statusIzdavanjeSelection: [
        "Izdato",
        "Nije izdato",
      ],
      statusProdajeSelection: [
        "Prodato",
        "Nije prodato",
      ],
      users:[],
    
    }),
    async mounted(){
      const id = this.$route.params.id
      this.id = id
      const data  = { searchID: id }
      try {
        // Simple GET request using axios
        await axios.post('/posts/get', data , {
        headers: {
            'Content-Type': 'application/json',
        }
       }).then(async response => {
          this.data = response.data.posts[0]
          this.data.old_images = this.data.images
          this.data.images = []
          this.data.price =  this.data.price.toString()
          this.data.size =  this.data.size.toString()

          const makeEditor = (field) => new Editor({
            extensions: [StarterKit, Underline],
            content: this.data[field] || '',
            onUpdate: ({ editor }) => {
              this.data[field] = editor.getHTML()
            }
          })
          this.editors.description = makeEditor('description')
          this.editors.descriptionEng = makeEditor('descriptionEng')
          this.editors.descriptionRus = makeEditor('descriptionRus')
       })

       axios.post("/users/getUsers")
            .then(async response => {
               this.users = await response.data.users
            })

       
       
      } catch (error) {
        console.log(error.message)
      }
    },
    beforeDestroy() {
      Object.values(this.editors).forEach(e => e && e.destroy())
    },
    methods: {
      async validate () {
        
        const validate = this.$refs.form.validate()

        if(validate){
         
          if(this.data.type == "Jednosoban")  this.data.roomsNum =  "1"
         if(this.data.type == "Dvosoban") this.data.roomsNum = "2"
         if(this.data.type == "Trosoban") this.data.roomsNum = "3"
         if(this.data.type == "Cetvorosoban") this.data.roomsNum = "4"
         if(this.data.type == "Petosoban") this.data.roomsNum = "5"
  


          var form_data = new FormData();

          for ( var key in this.data ) {
            await  form_data.append(key, this.data[key]);
          }

          form_data.set('agent', this.data.agent._id)
          form_data.delete('images');
          form_data.delete('old_images');
          for (const element of this.data.images) {
            form_data.append('images', element)
            
          }
          for (const element of this.data.old_images) {
            form_data.append('old_images', element)
            
          }
         


          
         

          // const Data = {data:form_data , id: this.id}

         await apiPost.EditPost({data:form_data, id:this.id}).then(async response => {
           console.log(response.data)
           this.$router.push('/admin/nekretnine')
         })
        }

      },
      reset () {
        this.$refs.form.reset()
      }
      
    },
  }
</script>


<style  scoped>
.form{
   width: 80%;
   padding: 30px;
}
.cardUp{
  padding:30px;
  width: 80%;
  display: flex;
  justify-content: left;
  align-items: center;
}
h4{
  font-weight: bold;
}
a{
  text-decoration: none;
}
.editor-wrap {
  border: 1px solid rgba(0,0,0,0.42);
  border-radius: 4px;
  padding: 8px;
}
.editor-label {
  font-size: 12px;
  color: rgba(0,0,0,0.6);
  display: block;
  margin-bottom: 6px;
}
.editor-toolbar {
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.editor-toolbar button {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 2px 10px;
  cursor: pointer;
  background: white;
  font-size: 13px;
}
.editor-toolbar button.active {
  background: rgba(33,111,253,255);
  color: white;
  border-color: rgba(33,111,253,255);
}
.toolbar-sep {
  display: inline-block;
  width: 1px;
  background: #ddd;
  height: 24px;
  margin: 0 4px;
  vertical-align: middle;
}
</style>
